<form [formGroup]="formName">
    <label>
        <input
            type="checkbox"
            [name]="field.fieldName"
            [formControlName]="field.fieldName"
            [value]="field.value"
            (change)="onCheckboxChange($event)"/>
        {{ field.label }}
    </label>
</form>